<template>
  <div>
    <div class="titlePageSub mt-3">Publicar</div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsSolicitacoesExportacao"
          orderby="data_finalizacao"
          :optionsButton="optionsButton"
          :items="lstSolicitacaoExportacao"
          responsive
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :titlePDF="titlePage"
          :mostrarQuantidade="false"
        ></fccTable>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '../../../store'

export default {
  data() {
    return {
      titlePage: 'Publicações',
      titleModalExportacao: '',
      sortBy: 'nome',
      criar: {},
      itemPorPage: '1000',
      lstSolicitacaoExportacao: [],
      solicitacao: {},
      fieldsSolicitacoesExportacao: [
        { key: 'nome_funcionario', label: 'Técnico', sortable: true },
        { key: 'dt_importacao', label: 'Data da Exportação', sortable: true }
      ],
      optionsButton: [
        {
          funcaoButton: 'publicarField',
          tooltip: 'Liberar',
          icon: 'check',
          text: 'Liberar',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ]
    }
  },
  methods: {
    publicarField() {
      this.callConfirm('Deseja liberar os tratamentos? ', '').then((result) => {
        if (result.value) {
          const criar = {
            spi: this.controlePage.spi,
            idPublicacao: this.idNotificacao,
            idPublicacaoSgp: this.controlePage.idpublicacao,
            cdFuncionario: this.dadosUserSession.usuCdFuncionario
          }
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .post(
              this.baseUrlPublicacao + 'InscricoesDeferidasCanceladas/PublicarTratamentoInscricao',
              criar,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then((response) => {
              if (response.status == 204) {
                this.callAlert('Fechamento de Cadastro não foi finalizado', '', 'error', 'error')
                return
              }
              this.carregaTexto()
              this.callToast(this.mensagensUpdate.adicionado, 'success')
              this.listarExportacaoInscricaoExportar()
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto)
        }
      })
    },
    listarExportacaoInscricaoExportar() {
      this.carregaTexto(this.codeMensagem('C01'))
      this.listarExportacaoInscricaoExportarGenerico(this.controlePage.spi, 1).then((response) => {
        this.lstSolicitacaoExportacao = response

        this.$emit('exportarOk', this.lstSolicitacaoExportacao.length > 0 ? true : false)
        this.carregaTexto()
      })
    }
  },
  props: {
    controlePage: Object,
    idNotificacao: Number,
    baseUrlPublicacao: String
  },
  mounted() {
    this.listarExportacaoInscricaoExportar()
  }
}
</script>
